<template>
    <MainContent title="INFORME CONTROL DE ACCESOS">
        <template v-slot:header>
            <h4>INFORME CONTROL DE ACCESOS</h4>
            <Button class="ml-2 mb-2" @click="$modal.show('descargar-informe-control')">DESCARGAR INFORME CONTROL ACCESO</Button>
        </template>
        <template v-slot:content>
            <b-card no-body>
                <b-tabs card >
                    <b-tab title="Entradas" :active="active == 'entradas'" @click="active = 'entradas'">
                        <div class="tab-content-horizontal-scroll">
                            <ListadoControlDeAccesosEntradas v-if="active == 'entradas'" />
                        </div>
                    </b-tab>
                    <b-tab title="Entradas Abonados" :active="active == 'abonados'" @click="active = 'abonados'">
                        <div class="tab-content-horizontal-scroll">
                            <ListadoControlDeAccesosAbonos v-if="active == 'abonados'"/>
                        </div>
                    </b-tab>
                    <b-tab title="Entradas Otros" :active="active == 'entradas_otros'" @click="active = 'entradas_otros'">
                        <div class="tab-content-horizontal-scroll">
                            <ListadoControlDeAccesosEntradasOtros v-if="active == 'entradas_otros'"/>
                        </div>
                    </b-tab>
                </b-tabs>
            </b-card>
            <DescargarInformeControlAcceso name="descargar-informe-control" :evento="evento" :sesion_id="sesion_id" :taquillero_id="null" v-on:close="$modal.hide('descargar-informe-control')" />
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import DescargarInformeControlAcceso from '@/views/backend/events/modals/DescargarInformeControlAcceso';
    import ListadoControlDeAccesosEntradas from "@/components/backend/eventos/sesiones/informe/ListadoControlDeAccesosEntradas.vue";
    import ListadoControlDeAccesosAbonos from "@/components/backend/eventos/sesiones/informe/ListadoControlDeAccesosAbonos.vue";
    import ListadoControlDeAccesosEntradasOtros from "@/components/backend/eventos/sesiones/informe/ListadoControlDeAccesosEntradasOtros.vue";
    export default {
        data() {
            return {
                evento_id :this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
                evento: {},
                active: 'entradas',
            };
        },
        created() {
            this.getEvent();
        },
        methods: {
            getEvent : function() {
                const params = {
                    filters : {},
                    evento_id: this.evento_id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.show'), params).then(res => {
                    this.evento = res.data.data;
                })
            },
        },
        components: {
            MainContent, DescargarInformeControlAcceso, ListadoControlDeAccesosEntradas,
            ListadoControlDeAccesosAbonos, ListadoControlDeAccesosEntradasOtros
        }
    };
</script>

<style scoped>
.tab-content-horizontal-scroll {
    overflow-x: auto; 
    width: 100%; 
    display: block; 
}
</style>